import axios from "axios";
import { create } from "zustand";

export let useOrders = create((set, get) => ({
    orders: [],
    ed: {},
    columns: [
        {
            title: 'Buyurtma raqami',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Xaridor',
            dataIndex: 'user_id',
            key: 'user_id',
        },
        {
            title: 'Viloyat',
            dataIndex: 'region_id',
            key: 'region_id',
        },
        {
            title: 'Tuman',
            dataIndex: 'district_id',
            key: 'district_id',
        },
        {
            title: 'Manzil',
            dataIndex: 'address',
            key: 'address',
        },
        {
            title: 'Telefon',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Jami summa',
            dataIndex: 'total_summ',
            key: 'total_summ',
        },
        {
            title: 'Maxsulot Soni',
            dataIndex: 'items_count',
            key: 'items_count',
        },
    ],
    getOrders: () => {
        axios.get("/orders").then(res => {
            set({ orders: res.data })
        })
    },
    addOrder: (order) => {
        axios.post("/orders", order).then(res => {
            set({ orders: [...get().orders, res.data] })
        })
    },
    updateOrder: (updatedOrder) => {
        axios.put(`/orders/${updatedOrder.id}`, updatedOrder).then(res => {
            set({ orders: get().orders.map(o => o.id === updatedOrder.id ? updatedOrder : o) })
        })
    },
    deleteOrder: (id) => {
        axios.delete(`/orders/${id}`).then(res => {
            set({ orders: get().orders.filter(order => order.id !== id) })
        })
    },
    searchOrder: (param) => {
        if (param.length >= 1) {
            axios.get(`/orders/${param}`).then(res => {
                set({ orders: res.data })
            })
        }
    }
}))